import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SharedComponentsModule } from "./sharedComponents.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BsDatepickerConfig, BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { JQ_TOKEN } from './school/components/jQuery.service';


const jQuery = window["$"];

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedComponentsModule,
    BrowserAnimationsModule,
    BsDatepickerModule.forRoot(),
  ],
  providers: [
    {provide: JQ_TOKEN, useValue: jQuery},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

